import type { DevCycleUser } from '@devcycle/react-client-sdk';

export const buildFeatureFlagUser = ({
    createUserId,
    createUserEmail,
    currentOrganizationId,
    currentProjectId
}: {
    createUserId: string | undefined;
    createUserEmail: string | undefined;
    currentOrganizationId?: string;
    currentProjectId?: string;
}): DevCycleUser => ({
    user_id: createUserId,
    email: createUserEmail,
    customData: {
        projectId: currentProjectId ?? null,
        organizationId: currentOrganizationId ?? null
    }
});
